.reverse {
  svg {
    transform: scaleY(-1);
  }
}
